import * as React from "react"
import theme from "../theme"
import { Flex } from "rebass"

export const TableHeading = (props: any) => (
  <Flex
    {...props}
    alignItems="center"
    color={theme.colors.text}
    fontSize={["0.9rem", "1.1rem", "1.5rem"]}
    style={{
      fontWeight: 800,
      textAlign: "center",
      color: theme.colors.text
    }}
    p={["0.5rem", "0.75rem"]}
  />
)
